/**************************************************
 * Nombre:       MenuLateral
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Drawer, Grid} from "@mui/material";
import {useState} from "react";
import {theme} from "../../Tema";
import {useMediaQuery} from "@mui/system";
import MainDashboard from "./MainDashboard";
import LogoMenu from "./SubComponentes/LogoMenu";
import ListaMenu from "./SubComponentes/ListaMenu";
import TarjetaUsuario from "./SubComponentes/TarjetaUsuario";

const MenuLateral = ({seccionesProcesadas, secciones, seccionesPerfil, seccionesID}) => {
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const [open, setOpen] = useState(masSM)
    const anchoMax = 270
    const anchoMin = 86

    return (
        <>

            <Drawer
                onClose={() => setOpen(false)}
                open={open}
                anchor={'left'}
                variant={masSM ? 'permanent' : 'temporary'}
                PaperProps={{
                    sx: {
                        borderRight: 1,
                        backgroundColor: theme.palette.primary.light,
                        boxShadow: open ? 0 : 12,
                        overflow: 'hidden',
                        borderColor: '#ffffff50',
                        background: 'linear-gradient(151deg, rgba(255, 255, 255, 0.10) 6.5%, rgba(45, 45, 45, 0.10) 59.48%)',
                        backdropFilter: 'blur(5px)',
                        color: '#fff',

                    }
                }}

            >

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    sx={{
                        width: open ? anchoMax : anchoMin,
                        px: 3,
                        paddingTop: 1.6,
                        transition: "all .4s ease-in-out",
                        overflow: 'hidden',
                    }}
                >


                    <LogoMenu open={open}/>

                    <ListaMenu open={open} setOpen={setOpen} seccionesProcesadas={seccionesProcesadas}/>

                    {open &&
                        <TarjetaUsuario/>
                    }

                </Grid>


            </Drawer>


            <MainDashboard open={open} setOpen={setOpen} masSM={masSM} secciones={secciones}
                           seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>


        </>
    )

}
export default MenuLateral
